import { memo } from "react";
import { Form, InputField, Text, useForm, useLoader, useTheme } from "react-better-html";

import { useI18n } from "../../../utils/i18n";
import { useReduxAction, useReduxState } from "../../../utils/hooks";

import Section from "../../../components/structure/Section";

function PersonalInfoSection() {
   const theme = useTheme();
   const { t } = useI18n();
   const editFirebaseUserDataIsLoading = useLoader("user:editFirebaseUserData");
   const editUserDataIsLoading = useLoader("user:editUserData");

   const firebaseUser = useReduxState((state) => state.user.firebaseUser);

   const editFirebaseUserData = useReduxAction((actions) => actions.user.editFirebaseUserData);
   const editUserData = useReduxAction((actions) => actions.user.editUserData);

   const form = useForm({
      defaultValues: {
         fullName: firebaseUser?.displayName ?? "",
         email: firebaseUser?.email ?? "",
      },
      requiredFields: ["fullName", "email"],
      onSubmit: (values) => {
         editFirebaseUserData({
            displayName: values.fullName,
            onSuccess: () => {
               editUserData({
                  data: {
                     name: values.fullName,
                  },
                  onSuccess: (response) => {
                     form.setDefaultFieldsValue({
                        fullName: response.name,
                     });
                  },
               });
            },
         });
      },
   });

   return firebaseUser ? (
      <Section
         title={t((l) => l.pages.account.sections.personalInfo.title)}
         description={t((l) => l.pages.account.sections.personalInfo.description)}
      >
         <Form
            form={form}
            gap={theme.styles.gap}
            submitButtonText={t((l) => l.common.save)}
            submitButtonIsLoading={editFirebaseUserDataIsLoading || editUserDataIsLoading}
            submitButtonIsDisabled={!form.isDirty}
            renderActionButtons={
               !form.isDirty ? (
                  <Text fontSize={14} color={theme.colors.textSecondary} marginLeft={theme.styles.gap}>
                     {t((l) => l.components.form.nothingToSave)}
                  </Text>
               ) : undefined
            }
         >
            <InputField
               label={t((l) => l.common.fullName)}
               backgroundColor={theme.colors.backgroundBase}
               {...form.getInputFieldProps("fullName")}
            />

            <InputField.email
               label={t((l) => l.common.email)}
               backgroundColor={theme.colors.backgroundBase}
               disabled
               infoText={t((l) => l.pages.account.sections.personalInfo.form.emailInfoText)}
               {...form.getInputFieldProps("email")}
            />
         </Form>
      </Section>
   ) : undefined;
}

export default memo(PersonalInfoSection);
